import { BooleanFeature } from "./BooleanFeature";
import { FeatureCell } from "./FeatureCell";
import { usePlans } from "./PlansContext";
import { StringFeature } from "./StringFeature";

interface FeatureRowProps {
  basic?: boolean | string;
  business?: boolean | string;
  enterprise?: boolean | string;
  hideCheckIcon?: boolean;
  plus?: boolean | string;
  professional?: boolean | string;
  title: string;
}

export const FeatureRow = ({
  title,
  basic,
  professional,
  business,
  enterprise,
  plus,
  hideCheckIcon = false,
}: FeatureRowProps) => {
  const { compareTablePlanFeatures } = usePlans();

  const tierValues = { basic, professional, business, enterprise, plus };
  const availableTiers = Object.entries(tierValues).filter(
    ([tier]) =>
      compareTablePlanFeatures &&
      Object.keys(compareTablePlanFeatures).some(
        (compareTableTier: string) => compareTableTier === tier,
      ),
  );

  return (
    <>
      <FeatureCell>
        <StringFeature className="pr-5" value={title} hideCheckIcon />
      </FeatureCell>
      {availableTiers.map(([tier, value]) => (
        <FeatureCell key={tier}>
          {typeof value === "string" ? (
            <StringFeature value={value} hideCheckIcon={hideCheckIcon} />
          ) : (
            <BooleanFeature value={!!value} />
          )}
        </FeatureCell>
      ))}
    </>
  );
};
